import { render } from "./LiveStreamComparison.vue?vue&type=template&id=5b7223b6&scoped=true"
import script from "./LiveStreamComparison.vue?vue&type=script&lang=js"
export * from "./LiveStreamComparison.vue?vue&type=script&lang=js"

import "./LiveStreamComparison.vue?vue&type=style&index=0&id=5b7223b6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7223b6"]])

export default __exports__